export const DD_MM_YYYY_UI_FORMAT = 'DD-MM-YYYY';
export const DD_MM_YYYY = 'DD/MM/YYYY';
export const YEARS = 'years';
export const MONTHS = 'months';
export const MONTH = 'month';
export const DAY = 'day';
export const DATE_LENGTH_WITHOUT_SPECIAL_CHARS = 8;
